import {
  LineOfCreditTransactionView,
  SlTitledListComponent,
} from '@varo/graphql-schema-types';
import { router } from 'expo-router';
import mapToTransactionDetails from 'features/lineOfCredit/screens/activeDetailsScreen/adapters/mapToTransactionDetails';
import { TransactionGroup } from 'shared/components/TransactionSectionList/TransactionSectionList';
import { amountStyles } from 'shared/components/vxl/TransactionListItem/TransactionListItem';

const mapToTransactionSectionList = (
  transaction: SlTitledListComponent,
  disablePress = false,
): TransactionGroup => {
  return {
    title: transaction.title?.copy || '',
    transactions: transaction.children.map((child) => {
      const lineOfCreditTransaction: LineOfCreditTransactionView =
        mapToTransactionDetails({ transaction: child });

      return {
        secondaryDetail: child.secondaryDetail?.copy || '',
        titleText: child.primaryText?.copy || '',
        amountText: child.primaryDetail?.copy || '',
        secondaryText: child.secondaryText?.copy || '',
        balanceText: child.secondaryDetail?.copy || '',
        isPending: false,
        analyticsId: 'transactionViewed',
        customAttributes: {
          amount: child.primaryDetail?.copy || '',
          account_type: 'vloc',
        },
        amountStyle: lineOfCreditTransaction.accountFrom
          ? amountStyles.NEUTRAL
          : amountStyles.POSITIVE,
        onPress: disablePress
          ? undefined
          : () => {
              router.navigate({
                pathname: '/varo-line-of-credit/transaction-details',
                params: {
                  amount:
                    lineOfCreditTransaction.amount?.formattedWithPlusPrefix,
                  accountFrom: lineOfCreditTransaction.accountFrom,
                  accountTo: lineOfCreditTransaction.accountTo,
                  date: lineOfCreditTransaction.date,
                  description: lineOfCreditTransaction.description,
                  status: lineOfCreditTransaction.status,
                  subcategory: 'vloc_repayment',
                },
              });
            },
      };
    }),
  };
};

export default mapToTransactionSectionList;
